import { useTranslation } from 'react-i18next'

import { updateRentalPortalListing } from '../../../../../../api'
import { QA_NAME_SAVE_BTN } from '../../../../../../constants/qa'
import { parseServerValidation } from '../../../../../../utils/validation'
import { FormModal } from '../../../../../Form'
import { getIsListingChangedConflictError } from '../../../../../RentalPortalListing'

import { QA_NAME_LISTING_RESPONSIBLE_MANAGER_MODAL } from './ListingResponsibleManagerModal.constants'
import {
  getListingResponsibleManagerPayload,
  getListingResponsibleManagerValidationSchema,
} from './ListingResponsibleManagerModal.utils'
import { ListingResponsibleManagerModalFields } from './ListingResponsibleManagerModalFields'

function ListingResponsibleManagerModal({
  initialValues,
  listingId,
  version,
  onClose,
  onConflict,
  onSave,
}) {
  const { t } = useTranslation()

  async function handleSubmit({ setErrors, setSubmitting, values }) {
    return updateRentalPortalListing({
      data: getListingResponsibleManagerPayload(values),
      id: listingId,
      version,
    })
      .then(onSave)
      .catch(error => {
        setSubmitting(false)

        if (getIsListingChangedConflictError(error)) {
          onConflict(error)
        } else {
          setErrors(
            parseServerValidation(
              t('RentalPortal.ListingProfileResponsibleManagerSaveErrorKey')
            )
          )
        }
      })
  }

  return (
    <FormModal
      Fields={ListingResponsibleManagerModalFields}
      containerProps={{ qaName: QA_NAME_LISTING_RESPONSIBLE_MANAGER_MODAL }}
      formBodyProps={{
        submitQaName: QA_NAME_SAVE_BTN,
        withNotifications: true,
      }}
      formTitle='RentalPortal.ListingProfileResponsibleManagerModalTitleKey'
      initialValues={initialValues}
      validationSchema={getListingResponsibleManagerValidationSchema({
        initialValues,
      })}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default ListingResponsibleManagerModal
